/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkConvertProspectDto } from '../models/work-convert-prospect-dto';
import { WorkCreateProspectDto } from '../models/work-create-prospect-dto';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkProspect } from '../models/work-prospect';
import { WorkProspectDuplicatesDto } from '../models/work-prospect-duplicates-dto';
import { WorkUpdateProspectDto } from '../models/work-update-prospect-dto';

@Injectable({ providedIn: 'root' })
export class WorkProspectsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `prospectsV2ControllerFindAllPaginated()` */
  static readonly ProspectsV2ControllerFindAllPaginatedPath = '/v2/prospects';

  /**
   * Required permissions: prospects:read, prospects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `prospectsV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  prospectsV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 50
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by status query param.
     *           <p>
     *              <b>Format: </b> filter.status={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.status=$not:$like:John Doe&filter.status=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.status'?: Array<string>;

    /**
     * Filter by assigneeId query param.
     *           <p>
     *              <b>Format: </b> filter.assigneeId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.assigneeId=$not:$like:John Doe&filter.assigneeId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li></ul>
     */
      'filter.assigneeId'?: Array<string>;

    /**
     * Filter by createdBy query param.
     *           <p>
     *              <b>Format: </b> filter.createdBy={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.createdBy=$not:$like:John Doe&filter.createdBy=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.createdBy'?: Array<string>;

    /**
     * Filter by containertypeId query param.
     *           <p>
     *              <b>Format: </b> filter.containertypeId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.containertypeId=$not:$like:John Doe&filter.containertypeId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.containertypeId'?: Array<string>;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> created:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>created</li>
     * <li>objectCity</li>
     * <li>objectStreet</li>
     * <li>objectZip</li>
     * <li>status</li>
     * <li>company</li>
     * <li>lastName</li></ul>
     */
      sortBy?: Array<'created:ASC' | 'created:DESC' | 'objectCity:ASC' | 'objectCity:DESC' | 'objectStreet:ASC' | 'objectStreet:DESC' | 'objectZip:ASC' | 'objectZip:DESC' | 'status:ASC' | 'status:DESC' | 'company:ASC' | 'company:DESC' | 'lastName:ASC' | 'lastName:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> title,objectStreet,objectZip,objectCity,company
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>title</li>
     * <li>objectStreet</li>
     * <li>objectZip</li>
     * <li>objectCity</li>
     * <li>company</li>
     * <li>firstName</li>
     * <li>lastName</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkProspect>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'status'?: (string | Array<string>);
'assigneeId'?: (string | Array<string>);
'createdBy'?: (string | Array<string>);
'containertypeId'?: (string | Array<string>);
'active'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProspectsV2Service.ProspectsV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.status', params['filter.status'], {});
      rb.query('filter.assigneeId', params['filter.assigneeId'], {});
      rb.query('filter.createdBy', params['filter.createdBy'], {});
      rb.query('filter.containertypeId', params['filter.containertypeId'], {});
      rb.query('filter.active', params['filter.active'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkProspect>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'status'?: (string | Array<string>);
        'assigneeId'?: (string | Array<string>);
        'createdBy'?: (string | Array<string>);
        'containertypeId'?: (string | Array<string>);
        'active'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: prospects:read, prospects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `prospectsV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  prospectsV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 50
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by status query param.
     *           <p>
     *              <b>Format: </b> filter.status={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.status=$not:$like:John Doe&filter.status=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.status'?: Array<string>;

    /**
     * Filter by assigneeId query param.
     *           <p>
     *              <b>Format: </b> filter.assigneeId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.assigneeId=$not:$like:John Doe&filter.assigneeId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li></ul>
     */
      'filter.assigneeId'?: Array<string>;

    /**
     * Filter by createdBy query param.
     *           <p>
     *              <b>Format: </b> filter.createdBy={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.createdBy=$not:$like:John Doe&filter.createdBy=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.createdBy'?: Array<string>;

    /**
     * Filter by containertypeId query param.
     *           <p>
     *              <b>Format: </b> filter.containertypeId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.containertypeId=$not:$like:John Doe&filter.containertypeId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.containertypeId'?: Array<string>;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> created:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>created</li>
     * <li>objectCity</li>
     * <li>objectStreet</li>
     * <li>objectZip</li>
     * <li>status</li>
     * <li>company</li>
     * <li>lastName</li></ul>
     */
      sortBy?: Array<'created:ASC' | 'created:DESC' | 'objectCity:ASC' | 'objectCity:DESC' | 'objectStreet:ASC' | 'objectStreet:DESC' | 'objectZip:ASC' | 'objectZip:DESC' | 'status:ASC' | 'status:DESC' | 'company:ASC' | 'company:DESC' | 'lastName:ASC' | 'lastName:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> title,objectStreet,objectZip,objectCity,company
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>title</li>
     * <li>objectStreet</li>
     * <li>objectZip</li>
     * <li>objectCity</li>
     * <li>company</li>
     * <li>firstName</li>
     * <li>lastName</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkProspect>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'status'?: (string | Array<string>);
'assigneeId'?: (string | Array<string>);
'createdBy'?: (string | Array<string>);
'containertypeId'?: (string | Array<string>);
'active'?: (string | Array<string>);
};
};
}> {
    return this.prospectsV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkProspect>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'status'?: (string | Array<string>);
'assigneeId'?: (string | Array<string>);
'createdBy'?: (string | Array<string>);
'containertypeId'?: (string | Array<string>);
'active'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkProspect>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'status'?: (string | Array<string>);
'assigneeId'?: (string | Array<string>);
'createdBy'?: (string | Array<string>);
'containertypeId'?: (string | Array<string>);
'active'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `prospectsV2ControllerCreate()` */
  static readonly ProspectsV2ControllerCreatePath = '/v2/prospects';

  /**
   * Required permissions: prospects:create, prospects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `prospectsV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  prospectsV2ControllerCreate$Response(
    params: {
      body: WorkCreateProspectDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProspect>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProspectsV2Service.ProspectsV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProspect>;
      })
    );
  }

  /**
   * Required permissions: prospects:create, prospects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `prospectsV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  prospectsV2ControllerCreate(
    params: {
      body: WorkCreateProspectDto
    },
    context?: HttpContext
  ): Observable<WorkProspect> {
    return this.prospectsV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProspect>): WorkProspect => r.body)
    );
  }

  /** Path part for operation `prospectsV2ControllerFindOneById()` */
  static readonly ProspectsV2ControllerFindOneByIdPath = '/v2/prospects/{id}';

  /**
   * Required permissions: prospects:read, prospects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `prospectsV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  prospectsV2ControllerFindOneById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProspect>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProspectsV2Service.ProspectsV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProspect>;
      })
    );
  }

  /**
   * Required permissions: prospects:read, prospects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `prospectsV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  prospectsV2ControllerFindOneById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkProspect> {
    return this.prospectsV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProspect>): WorkProspect => r.body)
    );
  }

  /** Path part for operation `prospectsV2ControllerDelete()` */
  static readonly ProspectsV2ControllerDeletePath = '/v2/prospects/{id}';

  /**
   * Required permissions: prospects:delete, prospects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `prospectsV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  prospectsV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProspectsV2Service.ProspectsV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: prospects:delete, prospects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `prospectsV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  prospectsV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.prospectsV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `prospectsV2ControllerUpdate()` */
  static readonly ProspectsV2ControllerUpdatePath = '/v2/prospects/{id}';

  /**
   * Required permissions: prospects:update, prospects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `prospectsV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  prospectsV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateProspectDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProspect>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProspectsV2Service.ProspectsV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProspect>;
      })
    );
  }

  /**
   * Required permissions: prospects:update, prospects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `prospectsV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  prospectsV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateProspectDto
    },
    context?: HttpContext
  ): Observable<WorkProspect> {
    return this.prospectsV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProspect>): WorkProspect => r.body)
    );
  }

  /** Path part for operation `prospectsV2ControllerFindDuplicates()` */
  static readonly ProspectsV2ControllerFindDuplicatesPath = '/v2/prospects/{id}/duplicates';

  /**
   * Required permissions: prospects:read, prospects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `prospectsV2ControllerFindDuplicates()` instead.
   *
   * This method doesn't expect any request body.
   */
  prospectsV2ControllerFindDuplicates$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProspectDuplicatesDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProspectsV2Service.ProspectsV2ControllerFindDuplicatesPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProspectDuplicatesDto>;
      })
    );
  }

  /**
   * Required permissions: prospects:read, prospects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `prospectsV2ControllerFindDuplicates$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  prospectsV2ControllerFindDuplicates(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkProspectDuplicatesDto> {
    return this.prospectsV2ControllerFindDuplicates$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProspectDuplicatesDto>): WorkProspectDuplicatesDto => r.body)
    );
  }

  /** Path part for operation `prospectsV2ControllerConvert()` */
  static readonly ProspectsV2ControllerConvertPath = '/v2/prospects/{id}/convert';

  /**
   * Required permissions: prospects:update, prospects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `prospectsV2ControllerConvert()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  prospectsV2ControllerConvert$Response(
    params: {
      id: number;
      body: WorkConvertProspectDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProspect>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProspectsV2Service.ProspectsV2ControllerConvertPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProspect>;
      })
    );
  }

  /**
   * Required permissions: prospects:update, prospects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `prospectsV2ControllerConvert$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  prospectsV2ControllerConvert(
    params: {
      id: number;
      body: WorkConvertProspectDto
    },
    context?: HttpContext
  ): Observable<WorkProspect> {
    return this.prospectsV2ControllerConvert$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProspect>): WorkProspect => r.body)
    );
  }

}
